import React, { useState } from "react";
import LoginUserAPI from "../api/LoginUserAPI";
import { useNavigate } from "react-router-dom";
import ErrorAlert from "../../../components/ErrorAlert";
import logo from "../../../asset/images/Rizik-Arb-logo.png";
import InputField from "../../../components/InputField";
import HandleInputChange from "../../../utils/HandleInputChange";

function LoginUser() {
  // user data
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const navigate = useNavigate();
  const [errorAlert, setErrorAlert] = useState(false);

  // store user data int Local Storage
  const storeUserData = (userData) => {
    const { id, username, name, region, token, notification, privilege } = userData;
    localStorage.setItem(
      "user",
      JSON.stringify({ id, username, name, region, token, notification, privilege })
    );
  };

  // redirect user into main page if admin user else orders page only.
  const redirectUser = (userPrivilege) => {
    return userPrivilege === 1
      ? navigate(`${process.env.PUBLIC_URL}/`)
      : navigate(`${process.env.PUBLIC_URL}/orders`);
  };

  // handle login user  logic (redirect or show error message)
  const handleLoginUser = async (e) => {
    e.preventDefault();
    const userData = await LoginUserAPI(formData);
    if (userData) {
      storeUserData(userData);
      redirectUser(userData.privilege);
    } else {
      setErrorAlert(true);
      setTimeout(() => setErrorAlert(false), 5000);
    }
  };

  return (
    <>
      <div className="min-h-screen flex items-center justify-center">
        <div className="bg-white p-8 rounded border w-[25%]">
          <div className="mb-4 text-center">
            <img src={logo} alt="الشعار" className="w-64 mx-auto mb-4" />
            <h2 className="text-2xl font-semibold">تسجيل الدخول</h2>
          </div>
          <form method="POST" onSubmit={handleLoginUser} className="w-full">
            {errorAlert ? (
              <ErrorAlert
                title="خطا في عملية تسجيل الدخول"
                content="قد تكون البيانات الذي تم إستخدامها غير صحيحة, حاول مرة إخرى"
              />
            ) : (
              ""
            )}
            <InputField
              name="username"
              label="إسم المستخدم"
              value={formData.username}
              onChange={(e) => HandleInputChange(e, setFormData)}
            />

            <InputField
              name="password"
              label="كلمة المرور"
              type="password"
              value={formData.password}
              onChange={(e) => HandleInputChange(e, setFormData)}
            />
            <button type="submit" className="w-full bg-blue-500 text-white py-2 rounded">
              تسجيل الدخول
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default LoginUser;
